var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_3536505",
    clipPath: "url(#clip0_5191_13284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "background",
    d: "M21.5909 0H3.40909C1.5263 0 0 1.5263 0 3.40909V21.5909C0 23.4737 1.5263 25 3.40909 25H21.5909C23.4737 25 25 23.4737 25 21.5909V3.40909C25 1.5263 23.4737 0 21.5909 0Z",
    fill: "#0077B5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.00551 6.81818C9.00551 7.23959 8.88054 7.65154 8.64642 8.00193C8.4123 8.35231 8.07953 8.62541 7.6902 8.78668C7.30087 8.94794 6.87246 8.99014 6.45915 8.90792C6.04584 8.82571 5.66619 8.62278 5.3682 8.3248C5.07022 8.02682 4.86729 7.64717 4.78508 7.23386C4.70287 6.82055 4.74506 6.39214 4.90633 6.00281C5.0676 5.61347 5.34069 5.28071 5.69108 5.04658C6.04147 4.81246 6.45341 4.6875 6.87482 4.6875C7.43992 4.6875 7.98186 4.91198 8.38144 5.31156C8.78102 5.71114 9.00551 6.25309 9.00551 6.81818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.52184 10.3692V19.7826C8.52222 19.852 8.50886 19.9209 8.48255 19.9851C8.45623 20.0494 8.41747 20.1078 8.3685 20.1571C8.31953 20.2063 8.2613 20.2454 8.19718 20.272C8.13306 20.2987 8.0643 20.3124 7.99485 20.3124H5.74911C5.67967 20.3126 5.61087 20.2991 5.54668 20.2726C5.48249 20.2461 5.42416 20.2072 5.37505 20.1581C5.32595 20.109 5.28704 20.0506 5.26055 19.9864C5.23406 19.9222 5.22052 19.8534 5.22071 19.784V10.3692C5.22071 10.2291 5.27638 10.0947 5.37547 9.99559C5.47457 9.89649 5.60897 9.84082 5.74911 9.84082H7.99485C8.13475 9.8412 8.26879 9.89703 8.36758 9.99609C8.46637 10.0951 8.52184 10.2293 8.52184 10.3692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.2612 15.2698V19.8266C20.2614 19.8905 20.2489 19.9537 20.2246 20.0127C20.2002 20.0718 20.1645 20.1254 20.1193 20.1705C20.0742 20.2157 20.0205 20.2515 19.9615 20.2758C19.9025 20.3002 19.8392 20.3126 19.7754 20.3124H17.3606C17.2968 20.3126 17.2335 20.3002 17.1745 20.2758C17.1155 20.2515 17.0618 20.2157 17.0167 20.1705C16.9715 20.1254 16.9358 20.0718 16.9114 20.0127C16.8871 19.9537 16.8746 19.8905 16.8748 19.8266V15.4104C16.8748 14.7513 17.068 12.5241 15.1518 12.5241C13.6674 12.5241 13.3649 14.0482 13.3052 14.7329V19.8266C13.3052 19.9542 13.255 20.0767 13.1655 20.1676C13.0759 20.2585 12.9541 20.3105 12.8265 20.3124H10.4941C10.4304 20.3124 10.3673 20.2998 10.3085 20.2754C10.2496 20.251 10.1961 20.2152 10.1511 20.17C10.1061 20.1249 10.0705 20.0713 10.0462 20.0124C10.022 19.9535 10.0096 19.8903 10.0098 19.8266V10.328C10.0096 10.2643 10.022 10.2012 10.0462 10.1422C10.0705 10.0833 10.1061 10.0297 10.1511 9.98461C10.1961 9.93948 10.2496 9.90368 10.3085 9.87925C10.3673 9.85482 10.4304 9.84224 10.4941 9.84224H12.8265C12.9554 9.84224 13.0789 9.89342 13.17 9.98453C13.2611 10.0756 13.3123 10.1992 13.3123 10.328V11.1491C13.8635 10.3224 14.6802 9.68457 16.4231 9.68457C20.2839 9.68457 20.2612 13.2897 20.2612 15.2698Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5191_13284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.63f59495d50098f82502da641f26c208.svg";
export { ForwardRef as ReactComponent };